import * as React from 'react'
import { useEffect } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useFormikContext } from 'formik'
import { Note } from '../Fields/Note'
import { OwnerSelect } from '@user/components/Owner'
import { TypeCommonFields } from '../Fields/TypeCommonFields'
import { SalesTeamSelect } from '@user/components/Leads/AddLeadPage/FormFields/SalesTeamSelect/SalesTeamSelect'
import { LeadStatusSelect } from '@user/components/Leads/AddLeadPage/FormFields/LeadStatusSelect/LeadStatusSelect'
import { SalesFunnelSelect } from '@user/components/Leads/AddLeadPage/FormFields/SalesFunnelSelect/SalesFunnelSelect'

import { ENTITY_TYPES } from '@sales-center/common'
import { ImportUtilityModel } from '../../typings'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { useFieldOptionsData } from '../../hooks/useFieldOptionsData'
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from '@sales-center/components'
import { useDefaultHandlers } from '../hooks/useDefaultHandlers'
import { useData } from '../hooks/useData'
import { ImportDatePicker } from '../Fields/ImportDatePicker'

export function LeadFields() {
  const { values } = useFormikContext<ImportUtilityModel>()
  const tidalThemeActive = useTidalThemeActive()

  const { loading, fail } = useData()

  const {
    onChangeSalesFunnel,
    onChangeOwnerShip,
    onChangeLeadFunnelStage,
    onChangeSalesTeam,
  } = useDefaultHandlers()

  const { allSalesTeams, salesFunnels, salesFunnelStages } =
    useFieldOptionsData(values)

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  useEffect(() => {
    if (fail) {
      toast.error('Unable to retrieve Import Lookup data.')
    }
  }, [fail])

  return (
    <Box mb={5}>
      {loading ? (
        <>
          <Box pt={4.8} textAlign="center">
            <CircularProgress />
          </Box>
        </>
      ) : (
        <>
          <Note />
          <TypeCommonFields />
          <Grid mt={0.1} container spacing={2}>
            <Grid item xs={12}>
              <SalesTeamSelect
                name="salesTeamId"
                label="Sales Team"
                optionList={allSalesTeams}
                onChange={onChangeSalesTeam}
                disabled={false}
                required={false}
              />
            </Grid>
            <Grid item xs={12} mt={-1.5} mb={-1}>
              <OwnerSelect
                entityType={ENTITY_TYPES.Lead}
                salesTeamId={`${values.salesTeamId}`}
                name="assigneeId"
                useAdditionalMargin={true}
                errorText={''}
                testId="importUtilityOwner"
                required={false}
                disabled={false}
                defaultValue={''}
                onChange={onChangeOwnerShip}
              />
            </Grid>
            <Grid item xs={12}>
              <SalesFunnelSelect
                name="salesFunnelId"
                label="Sales Funnel"
                salesFunnels={salesFunnels}
                disabled={false}
                onChange={onChangeSalesFunnel}
                required={false}
              />
            </Grid>
            {/* //LeadStatus */}
            <Grid item xs={12}>
              <LeadStatusSelect
                name="leadFunnelStageId"
                label="Lead Status"
                disabled={false}
                onChange={onChangeLeadFunnelStage}
                salesFunnelStages={salesFunnelStages}
                density={density}
                required={false}
              />
            </Grid>
            {/* //Next Action Date */}
            <Grid item xs={12}>
              <ImportDatePicker
                label="Next Action Date"
                name="nextActionDate"
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  )
}
